import './styles.scoped.css';
import React, {useState} from 'react'

interface ScrollUpProps {
};

const ScrollUp: React.FC<ScrollUpProps> = ({}) => {

    const [visible, setVisible] = useState(false)
    const [kolor, setColor] = useState("#246193")

    const handleWite = () =>setColor('#e9eff4');
    const handleBlue = () =>setColor('#246193');

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true)
        }
        else if (scrolled <= 100) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div className='box' style={{ display: visible ? 'inline' : 'none' }}>
            <svg onClick={scrollToTop} onMouseOver={handleWite} onMouseOut={handleBlue} viewBox="0 0 32 32" className="icon icon-arrow-top arr" fill={kolor} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="48" height="48">
                <path d="M17.504 26.025l.001-14.287 6.366 6.367L26 15.979 15.997 5.975 6 15.971 8.129 18.1l6.366-6.368v14.291z" />
            </svg>
        </div>
    );
}

export default ScrollUp;